import { render, staticRenderFns } from "./Index2027.vue?vue&type=template&id=680f8514&scoped=true"
import script from "./Index2027.vue?vue&type=script&lang=js"
export * from "./Index2027.vue?vue&type=script&lang=js"
import style0 from "./Index2027.vue?vue&type=style&index=0&id=680f8514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680f8514",
  null
  
)

export default component.exports